import { createReducer, on } from '@ngrx/store';
import * as Actions from './report-view.actions';
import { initialReportViewsState, ReportViewsState, ReportViewState } from './report-view.model';

const _reportViewReducer = createReducer(
  initialReportViewsState,
  on(Actions.initializeReportViewSuccess, (state, action) => {
    const newState = <ReportViewsState>{...state, reports: [...state.reports]};
    console.log('initializeReportViewSuccess', action);
    const existing = newState.reports.find(rv => rv.reportName === action.reportName);
    if (existing) {
      newState.reports.splice(newState.reports.indexOf(existing), 1, action.reportViewState);
    } else {
      newState.reports.push(action.reportViewState);
    }
    return newState;
  }),
  on(Actions.selectPerspective, (state, action) => {
    const newState = {...state, reports: state.reports.map(rv =>
      rv.reportName === action.reportName ? {...rv, selectedPerspective: action.perspective} : rv
    )};
    return newState;
  })
);

export function reportViewReducer(state, action) {
  return _reportViewReducer(state, action);
}
